import React from 'react';
import { useSelector } from 'react-redux';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import LayerItem from './LayerItem';
import { getMapLayers } from '../reducers/mapLayers';

const getLayerItems = (layers, group) => layers.filter((layer) => layer.group === group).map((layer) => <LayerItem key={layer.id} id={layer.id} />);

const headerStyle = { color: '#606060', fontSize: '18px' };

const LayerList = () => {
  const layers = useSelector(getMapLayers);
  const neighborhoodItems = getLayerItems(layers, 'n');
  const blockGroupItems = getLayerItems(layers, 'bg');

  return (
    <>
      <Typography variant="h6" sx={headerStyle}>Municipalities / Neighborhoods</Typography>
      <List>
        {neighborhoodItems}
      </List>
      <Typography variant="h6" sx={headerStyle}>Block Groups</Typography>
      <List>
        {blockGroupItems}
      </List>
    </>
  );
};

export default LayerList;
